import { Get } from "./common";

export default class SettingService {
  static get = async (token: string) => await Get({ path: "settings/", token });
}
